import React from 'react'
import { CSSTransition } from 'react-transition-group'
import styles from './index.module.scss'

interface LeftAnimateWrapperProps {
  /** 是否显示内容 */
  in?: boolean
  /** 子组件 */
  children: React.ReactNode
  /** 动画时长（毫秒） */
  timeout?: number
  /** 是否在初始挂载时显示动画 */
  appear?: boolean
  /** 是否在退出时卸载 */
  unmountOnExit?: boolean
  /** 自定义样式类名 */
  className?: string
  /** 自定义动画类名 */
  classNames?: {
    enter?: string
    enterActive?: string
    exit?: string
    exitActive?: string
    appear?: string
    appearActive?: string
  }
  /** 进入动画完成回调 */
  onEntered?: () => void
  /** 退出动画完成回调 */
  onExited?: () => void
  /** 进入动画开始回调 */
  onEnter?: () => void
  /** 退出动画开始回调 */
  onExit?: () => void
}

const LeftAnimateWrapper: React.FC<LeftAnimateWrapperProps> = ({
  in: inProp = true,
  children,
  timeout = 500,
  appear = true,
  unmountOnExit = false,
  className = '',
  classNames,
  onEntered,
  onExited,
  onEnter,
  onExit
}) => {
  const defaultClassNames = {
    enter: styles.itemEnter,
    enterActive: styles.itemEnterActive,
    exit: styles.itemExit,
    exitActive: styles.itemExitActive,
    appear: styles.itemEnter,
    appearActive: styles.itemEnterActive
  }

  const mergedClassNames = classNames
    ? {
        enter: classNames.enter || defaultClassNames.enter,
        enterActive: classNames.enterActive || defaultClassNames.enterActive,
        exit: classNames.exit || defaultClassNames.exit,
        exitActive: classNames.exitActive || defaultClassNames.exitActive,
        appear: classNames.appear || defaultClassNames.appear,
        appearActive: classNames.appearActive || defaultClassNames.appearActive
      }
    : defaultClassNames

  const containerClass = [styles.width100, className].filter(Boolean).join(' ')

  return (
    <CSSTransition
      in={inProp}
      appear={appear}
      timeout={timeout}
      unmountOnExit={unmountOnExit}
      classNames={mergedClassNames}
      onEntered={onEntered}
      onExited={onExited}
      onEnter={onEnter}
      onExit={onExit}
    >
      <div className={containerClass}>{children}</div>
    </CSSTransition>
  )
}

export default LeftAnimateWrapper
